import React, { useMemo } from 'react';
import { type Location } from '@gql/schema';
import { Breadcrumbs as FalconBreadcrumbs, Link, LinkVariant } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useApplicationState } from '@utils/useApplicationState';
import { useTranslations } from '@utils/useTranslations';
import { getBreadcrumbs } from './Breadcrumbs.utils';

interface BreadcrumbsProps {
  location: Location;
}

export const Breadcrumbs = ({ location }: BreadcrumbsProps) => {
  const { territoryCode } = useApplicationState();
  const { translations } = useTranslations();

  const breadcrumbs = useMemo(
    () => getBreadcrumbs(i18n('breadcrumbs.home.label', [], translations), location, territoryCode),
    [translations, location, territoryCode]
  );

  return (
    <FalconBreadcrumbs>
      {breadcrumbs.map(({ label, href }) => (
        <Link variant={LinkVariant.black} key={label} href={href}>
          {label}
        </Link>
      ))}
    </FalconBreadcrumbs>
  );
};
